<template>
  <div class="athlete-wrapper">
    <div class="athlete-header">
      <span style="width: 20%">姓名</span>
      <span style="flex: 1">身份证号</span>
      <span style="width: 30%">发证日期</span>
    </div>
    <div class="swiper athlete-wheel">
      <div class="swiper-wrapper">
        <!--        <div class="swiper-slide" v-for="(item, index) in dataList" :key="index">-->
        <!--          <span style="width: 20%">{{ item.name }}</span>-->
        <!--          <span style="flex: 1">{{ item.certificates_number }}</span>-->
        <!--          <span style="width: 30%">{{ item.creationTime | dateformat("YYYY-MM-DD") }}</span>-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle'
import { GetAthleteList } from '@/api/admin/athletes'
import moment from 'moment'

export default {
  name: '',
  data() {
    return {
      dataList: [],
      swiper: null,
      athletePaging: {
        limit: 20,
        page: 1
      }
    }
  },
  created() {
    this.creSwiper()
    this.getAthleteList()
  },
  methods: {
    // 运动员列表
    getAthleteList() {
      GetAthleteList(this.athletePaging).then((data) => {
        this.athletePaging.page++
        let list = data.data.result
        if (list) {
          if (list.items.length < this.athletePaging.limit) {
            this.athletePaging.page = 1
          }
          this.swiper.virtual.appendSlide(list.items)
        }
      })
    },
    creSwiper() {
      let _self = this
      this.$nextTick(() => {
        this.swiper = new Swiper('.athlete-wheel', {
          direction: 'vertical',
          slidesPerView: 8,
          allowTouchMove: false,
          autoplay: {
            delay: 0
          },
          speed: 3000,
          on: {
            slideChange: function () {
              if (this.isEnd) {
                _self.getAthleteList()
              }
            }
          },
          virtual: {
            renderSlide: function (slide, index) {
              return `<div class="swiper-slide">
                  <span style="width: 20%">${slide.name}</span>
                  <span style="flex: 1">${slide.certificates_number}</span>
                  <span style="width: 30%">${moment(slide.creationTime).format('YYYY-MM-DD')}</span>
                </div>`
            }
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.athlete-wrapper {
  height: 100%;
  width: 100%;
  text-align: center;
  overflow: hidden;

  .athlete-header {
    height: 40px;
    display: flex;
    justify-content: space-around;
    font-size: 14px;
    font-weight: 800;
    color: #b93229;
  }

  .athlete-wheel {
    width: 100%;
    height: calc(100% - 40px);

    .swiper-wrapper {
      transition-timing-function: linear;
    }

    /deep/ .swiper-slide {
      display: flex;
      justify-content: space-around !important;
      align-items: center;
      font-size: 14px;
      //border-bottom: 1px solid #e3e3e3;
    }
  }
}
</style>
